module.exports = __webpack_public_path__ + "images/boxes/storyline_1-daeff423b1096d8f8efd02451af9101c.webp";